import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

type Payload = Record<string, unknown>;

export const raitingReviewTripAdd = createApiSlice<unknown, Payload>({
  name: 'raitingReviewAdd',
  *tryGenerator(_, { payload: { data } }) {
    yield call(amplifyClient, {
      method: 'post',
      url: getEndpointV2({ path: '/tripmanage/reviews' }),
      data,
    });
    return null;
  },
});
